

import Swal from "sweetalert2";
import api from "../../../../utilities/interseptor";
const key = process.env.REACT_APP_CLAVE_INCRIPTACION;
const apiUrl = process.env.REACT_APP_API
export class crearEsquemaIntegracion {
    static agregarEsquema = (data, navigate) => {
        api.post(`${apiUrl}/monitor/programacion/consulta-esquemas/agregar`, data).then((res) => {
            if (res.data.status == 200) {
                Swal.fire({
                    icon: 'success',   // Icono de error
                    title: res.data.message, // Título de la alerta
                });
                navigate(-1)
            }
            else {
                Swal.fire({
                    icon: 'error',   // Icono de error
                    title: res.data.message, // Título de la alerta
                });
            }
        })
            .catch((error) => {
                Swal.fire({
                    icon: 'error',   // Icono de error
                    title: 'Oops...', // Título de la alerta
                    text: 'no fue pocible agregar la nueva esquema', // Mensaje de error
                    confirmButtonText: 'OK'  // Texto del botón de confirmación
                });
            })
    }
}